const addclosedownlist = {
  path: 'addclosedownlist',
  component: resolve => require(['@/pages/admin/aftersales/addclosedownlist'], resolve)
}

export default addclosedownlist
